import { Link } from "react-router-dom";

/**
 * What a signed-in visitor sees before any machine has reported.
 *
 * This is the first page most accounts ever see, so it is a set of
 * instructions rather than an apology. It also repeats what reporting sends,
 * word for word as the desktop's own checkbox puts it — someone deciding
 * whether to turn this on should not have to reconcile two descriptions of the
 * same thing, and if the two ever drift, the one being read here is the one
 * that was not shown at the moment of consent.
 */
export function NoDevices() {
  return (
    <section className="panel">
      <h2>No devices are reporting yet</h2>
      <p className="muted">
        This page fills in once a copy of Big Bear Backup is signed in to
        your account and has run a backup.
      </p>

      <ol className="setup-steps">
        <li>
          <Link to="/download">Install Big Bear Backup</Link> on the computer
          you want to watch, if it is not there already.
        </li>
        <li>
          In the app, open <strong>File → Sign in to the web portal…</strong> and
          sign in with this account.
        </li>
        <li>
          Leave <strong>Show these backups in the web portal</strong> ticked.
        </li>
        <li>Run a backup, or wait for the next scheduled one.</li>
      </ol>

      <p className="muted">
        Reporting sends the computer&rsquo;s name, your plan names, the folders
        each plan backs up, and when runs happened and how they went. Your
        files, your passphrases and the contents of your backups are never sent.
      </p>
    </section>
  );
}
